






































import { Component, Prop, Vue } from "vue-property-decorator";
import Vehicle from "../../models/vehicle";

@Component
export default class VehicleDetailHeader extends Vue {
  @Prop({ default: "grey" }) readonly color1!: string;
  @Prop({ default: "grey" }) readonly color2!: string;
  @Prop() readonly vehicle!: Vehicle | null;

  get breadcrumbs(): any[] {
    return this.features.map((x) => {
      return { text: x };
    });
  }

  get cardStyle() {
    return `background: linear-gradient(0deg, ${this.color1}, ${this.color2});`;
  }

  get features(): string[] {
    if (!this.vehicle) {
      return [];
    }

    var features: string[] = [];
    if (this.vehicle.engine.name) {
      features.push(`${this.vehicle.engine.name} Engine`);
    }

    if (this.vehicle.engine.horsepower) {
      features.push(`${this.vehicle.engine.horsepower} Horsepower`);
    }

    if (this.vehicle.mpg.combined) {
      features.push(`${this.vehicle.mpg.combined} Combined MPG`);
    }

    return features;
  }

  get title(): string | null {
    if (!this.vehicle) {
      return null;
    }
    return this.vehicle.displayName();
  }

  get imageUrl(): string | null {
    if (!this.vehicle) {
      return null;
    }
    return this.vehicle.imageUrl;
  }

  get vin(): string | null {
    if (!this.vehicle) {
      return null;
    }
    return this.vehicle.vin;
  }

  get location(): string {
    if (!this.vehicle || !this.vehicle.currentAddress) {
      return "Not Available";
    }
    return this.vehicle.cityStateZipCode() || "Not Available";
  }
}
